import styled from '@emotion/styled'

export const InvoiceSettingsWithPreviewWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  /* Custom margin & height adjustments due to ModuleLayout structure */
  /* The settings container adds 100px bottom padding, but this view only needs 20px — so we apply margin-bottom: -80px */
  /* To achieve full-height UX, we also offset 20px (bottom padding) + 148px (ModuleStickyHeader) = -168px total */
  height: calc(100vh - 168px);
  margin-bottom: -80px;
`
